import React from 'react';
import StatCard from '@/components/ui/StatCard';
import { Briefcase, Activity, CheckCircle2, TrendingUp, Wallet, IndianRupee } from 'lucide-react';

export const LeadExecutionStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full min-w-0">
      <StatCard 
        title="Total Executions" 
        value={stats?.totalExecutions || 0} 
        icon={<Briefcase />} 
        color="bg-amber-500"
        variant="dashboard"
      />
      <StatCard 
        title="Completed" 
        value={stats?.completedExecutions || 0} 
        icon={<CheckCircle2 />} 
        color="bg-emerald-500" 
        variant="dashboard"
      />
      <StatCard 
        title="Total PO Value" 
        value={stats?.totalRevenue || 0} 
        icon={<IndianRupee />} 
        color="bg-[#2B448F]" 
        variant="dashboard"
      />
      <StatCard 
        title="Total Balance Due" 
        value={stats?.totalBalance || 0} 
        icon={<Wallet />} 
        color="bg-indigo-600" 
        variant="dashboard"
      />
    </div>
  );
};
